import { render, staticRenderFns } from "./TableUserContacts.vue?vue&type=template&id=2a328fe9&"
import script from "./TableUserContacts.vue?vue&type=script&lang=js&"
export * from "./TableUserContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports